import { render, staticRenderFns } from "./YearSelector.vue?vue&type=template&id=22e8526e&scoped=true&"
import script from "./YearSelector.vue?vue&type=script&lang=js&"
export * from "./YearSelector.vue?vue&type=script&lang=js&"
import style0 from "./YearSelector.vue?vue&type=style&index=0&id=22e8526e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8526e",
  null
  
)

export default component.exports